import React, { useState, useEffect } from 'react';
import lightHouseImage from "../img/envision/valuefirst/cards/CIRCLE IT.jpg";

const AboutUs = () => {
  // State for counters
  const [customers, setCustomers] = useState(0);
  const [countries, setCountries] = useState(0);
  const [associates, setAssociates] = useState(0);
  const [projects, setProjects] = useState(0); // New state for Projects
  const [branches, setBranches] = useState(0); // New state for Branches

  // Effect to simulate counter increment
  useEffect(() => {
    const customerInterval = setInterval(() => {
      if (customers < 25) setCustomers(prev => prev + 1);
    }, 100);

    const countryInterval = setInterval(() => {
      if (countries < 200) setCountries(prev => prev + 100);
    }, 100);

    const associateInterval = setInterval(() => {
      if (associates < 5000) setAssociates(prev => prev + 100);
    }, 100);

    const projectInterval = setInterval(() => {
      if (projects < 10) {
        setProjects(10); // Directly set the value to 100000
        clearInterval(projectInterval); // Stop the interval
      }
    }, 100);


    const branchInterval = setInterval(() => {
      if (branches < 15) setBranches(prev => prev + 1); // Add a condition for branches
    }, 100);

    return () => {
      clearInterval(customerInterval);
      clearInterval(countryInterval);
      clearInterval(associateInterval);
      clearInterval(projectInterval); // Clear the project interval
      clearInterval(branchInterval); // Clear the branch interval
    };
  }, [customers, countries, associates, projects, branches]);  // Include new state dependencies

  return (
    <section className="about-us " style={{marginTop:'60px'}}>
      <div className="container">
        <div className="row" style={{width:'100%'}}>
          <div className="cyient-sec">
            <div className="col-lg-5 col-md-5">
              <div className="cyient-office-img">
                <div className="cyient-img">
                  <img
                    className="ls-is-cached lazyloaded what-we-img-home"
                    alt="Image"
                    loading="lazy"
                    style={{ width: '550px', height: '512px' }}
                    height="23"
                    width="480"
                    src={lightHouseImage}
                   
                 />
                </div>
                {/* Counter card positioned above the image */}
                <div className="counter-card datawhatwedo">
                  <div className="number-card">
                    <i className="fas fa-users" style={{ fontSize: '25px', color: 'rgb(236 115 34)' }}></i>  {/* Font Awesome icon for Customers */}
                    <span>{customers}+</span>
                    <p>Years of Average work Experience</p>
                  </div>
                  <div className="number-card">
                    <i className="fas fa-globe" style={{ fontSize: '25px', color: 'rgb(236 115 34)' }}></i>  {/* Font Awesome icon for Countries */}
                    <span>{countries}+</span>
                    <p>Global clients working Experience</p>
                  </div>

                  <div className="number-card">
                    <i className="fas fa-project-diagram" style={{ fontSize: '25px', color: 'rgb(236 115 34)' }}></i>  {/* Font Awesome icon for Projects */}
                    <span>{projects}+</span> {/* Display Projects */}
                    <p> Countries Footprint</p>
                  </div>

                  {/* <div className="number-card">
                    <i className="fas fa-building" style={{ fontSize: '25px', color: '#edcf39' }}></i> 
                    <span>{branches}+</span>
                    <p>Branches</p>
                  </div> */}

                  <div className="number-card">
                    <i className="fas fa-users-cog" style={{ fontSize: '25px', color: 'rgb(236 115 34)' }}></i>  {/* Font Awesome icon for Associates */}
                    <span>{associates}+</span>
                    <p>Projects Executed</p>
                  </div>
                </div>


              </div>
            </div>
            <div className="col-lg-7 col-md-7 what-data-home-how">
              <div className="about-sec">
                <div className="about-us-details">
                  <div className="about-head">
                    <h4><span style={{ color: 'rgb(236 115 34)' }}> Who We  </span> Are</h4>

                    <p style={{ fontSize: '17px',textAlign:'justify' }}>At DREBCON, we address the critical gaps in cybersecurity and governance that leave organizations vulnerable to failure. With 99% of cyberattacks stemming from inadequate controls and poor governance crippling enterprises, we take a proactive approach. Our process begins with thoroughly validating and remediating controls against industry-specific standards and compliances, creating a fool proof security radar.
                    </p>
                    {/* <h2 style={{ textAlign: 'center', marginTop: '10px', fontSize: '25px' }}> How do you create</h2> */}
                    <p style={{ fontSize: '17px', marginTop: '10px',textAlign:'justify' }}>
                    We establish robust governance frameworks aligned with business objectives, driving the design and delivery of AI-enabled IT and OT transformations. Spanning diverse industries, we inspect, design, and implement resilient systems that pave the way for a digital, autonomous, and sustainable future.
                    </p>

                    <p style={{ fontSize: '17px', marginTop: '10px',textAlign:'justify' }}>
                    Our unwavering commitment empowers customers with regulatory-compliant, globally competitive, cost-effective, and environmentally sustainable business solutions tailored to contemporary market demands. Backed by deep domain expertise across multiple sectors, we deliver excellence and adaptability in an ever-evolving landscape.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
  .about-us {
    padding: 0px 0;
  }

  .container {
    // width: 120%; 
    margin: 0 auto;
    padding: 0 15px; /* Optional: Add some padding to prevent content from sticking to edges */
  }

 

  .col-lg-6, .col-md-5, .col-md-7 {
    flex: 1;
  }

  .cyient-office-img {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .cyient-img img {
    height: auto;
    border-radius: 10px;
  }

  /* Counter card above the image */
  .counter-card {
    position: absolute;
    top: 512px;
    left: 151%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-around;
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 197%;
    z-index: 2;
  }

  .number-card {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 150px;
  }

  .number-card span {
    font-size: 32px;
    font-weight: bold;
    display: block;
    color: #000;
  }

  .number-card p {
    font-size: 14px;
    color: #777;
    margin-top: 5px;
  }

  .about-sec {
    padding: 20px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
   
  }

  .about-us-details {
    margin-bottom: 20px;
  }

  .about-head h4 {
    font-size: 34px;
    color: #333;
    margin-bottom: 10px;
    text-align: center;
  }

  .about-head p {
    font-size: 16px;
    color: #555;
    line-height: 1.5;
  }
`}</style>

    </section>
  );
};

export default AboutUs;
